import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AngularNodeViewComponent, TiptapDraggableDirective } from 'ngx-tiptap';

@Component({
    selector: 'admin-tiptap-email-receipt-container',
    templateUrl: `./tiptap-email-receipt-container.component.html`,
    styleUrls: ['./tiptap-email-receipt-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TiptapDraggableDirective, NgStyle, NgClass],
})
export class TiptapEmailReceiptContainerComponent extends AngularNodeViewComponent implements OnInit {
    get isEditable() {
        return this.editor().isEditable;
    }

    get styles() {
        const node = this.node();
        const textAlign = node.attrs['textAlign'] || 'left';

        return {
            'text-align': textAlign,
        };
    }

    ngOnInit(): void {}
}
